import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-list-bulleted",
  "use": "format-list-bulleted-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-list-bulleted\"><path fill-rule=\"evenodd\" d=\"M2.5 12c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Zm0-6c0 .83.67 1.5 1.5 1.5S5.5 6.83 5.5 6 4.83 4.5 4 4.5 2.5 5.17 2.5 6Zm.17 12c0 .73.6 1.33 1.33 1.33A1.33 1.33 0 1 0 2.67 18ZM21 19v-2H7v2h14Zm0-6v-2H7v2h14ZM7 7h14V5H7v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol